export default "__VITE_ASSET__76cbbf96__"